import { Directive, ElementRef, Renderer2, booleanAttribute, inject, input } from '@angular/core';

@Directive({
  selector: 'img[rmaBrokenImage]',
  standalone: true,
  host: {
    '(error)': 'onError()',
  },
})
export class BrokenImageDirective {
  private readonly renderer = inject(Renderer2);
  private readonly el = inject(ElementRef);

  public readonly fallbackSrc = input<string>();
  public readonly renderAlt = input(false, { transform: booleanAttribute });
  public readonly renderAltImageStyle = input(false, { transform: booleanAttribute });

  onError() {
    const image: HTMLImageElement = this.el.nativeElement as HTMLImageElement;

    const fallbackSrc = this.fallbackSrc();
    if (fallbackSrc) {
      this.renderer.setAttribute(image, 'src', fallbackSrc);
      return;
    }

    if (this.renderAlt()) {
      const alt = image.alt;

      if (alt) {
        const parent = this.el.nativeElement.parentElement;

        if (parent) {
          const div = this.renderer.createElement('div');

          if (this.renderAltImageStyle()) {
            const className = this.el.nativeElement.className;
            if (className) {
              this.renderer.addClass(div, className);
              return;
            }
          }

          const text = this.renderer.createText(alt);
          this.renderer.appendChild(div, text);
          this.renderer.appendChild(parent, div);
          return;
        }
      }
    }

    this.renderer.setStyle(image, 'display', 'none');
  }
}
